// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__Nx1hw","menuList":"Menu_menuList__3fnwk","menuItem":"Menu_menuItem__29cCL","menuLink":"Menu_menuLink__3C3q2"};